// /* eslint-disable jsx-a11y/img-redundant-alt */
// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import {
//   Typography,
//   Container,
//   Box,
//   TextField,
//   Button,
//   Breadcrumbs,
//   Link as MUILink,
// } from "@mui/material";
// import axios from "../../axiosInstance";
// import { Link } from "react-router-dom";
// import { useParams } from "react-router-dom";
// import { message, Table, Modal } from "antd";
// import IconButton from "@mui/material/IconButton";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import EditQuestionModal from "./EditQuestionModal";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import moment from "moment";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import QuestionPaperPDF from "./QuestionPaperPDF";
// import AddQuestions from "./AddQuestions";
// import { useSelector, useDispatch } from "react-redux";
// import { getCourses } from "../../redux/actions/admin/courseAction";
// import SearchIcon from "@mui/icons-material/Search";

// function CustomTabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// CustomTabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

// function TabPanel(index) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }

// export default function EditExamQuestion() {
//   let { id } = useParams();
//   const dispatch = useDispatch();
//   const { courses } = useSelector((state) => state.courses);
//   const [value, setValue] = useState(0);
//   const [name, setName] = useState("");
//   const [subject, setSubject] = useState("");
//   const [className, setClassName] = useState("");
//   const [duration, setDuration] = useState("");
//   const [totalMarks, setTotalMarks] = useState("");
//   const [passingMarks, setPassingMarks] = useState("");
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [startTime, setStartTime] = useState("");
//   const [endTime, setEndTime] = useState("");
//   const [questions, setQuestions] = useState([]);
//   const [editQuestionModal, setEditQuestionModal] = useState(false);
//   const [selectedQuestion, setSelectedQuestion] = useState(null);
//   const [negativeMarking, setNegativeMarking] = useState("");
//   const [examSet, setExamSet] = useState("");
//   const [instituteId, setInstituteId] = useState("");
//   const [vendorId, setVendorId] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [studentCourseId, setStudentCourseId] = useState("");
//   const [studentCourse, setStudentCourse] = useState("");
//   const [publicExam, setPublicExam] = useState("");
//   const [category, setCategory] = useState("");
//   const [exam, setExam] = useState(null);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const handleStartDateChange = (date) => {
//     setStartDate(date);
//   };

//   const handleEndDateChange = (date) => {
//     setEndDate(date);
//   };

//   // Format dates for API
//   const examStartDate = startDate ? moment(startDate).format("DD/MM/YYYY") : "";
//   const examEndDate = endDate ? moment(endDate).format("DD/MM/YYYY") : "";

//   // Fetch all institute courses
//   useEffect(() => {
//     dispatch(getCourses());
//   }, [dispatch]);

//   useEffect(() => {
//     if (courses) {
//       setStudentCourse(courses);
//     }
//   }, [courses]);

//   useEffect(() => {
//     getAllExams();
//   }, [id]);

//   // Handle Institute Course selection change
//   const handleChangeStudentCourse = (event) => {
//     const selectedCourseName = event.target.value;
//     setStudentCourse(selectedCourseName);

//     const generalCourseId = "81af3e57846a42aab058dc4d";

//     const selectedCourse = courses?.find(
//       (course) => course.name === selectedCourseName
//     );

//     if (selectedCourse) {
//       setStudentCourseId(selectedCourse._id);
//     } else if (selectedCourseName === "General") {
//       setStudentCourseId(generalCourseId);
//     }
//   };

//   // Get all Exams
//   const getAllExams = async () => {
//     try {
//       const response = await axios.get(`/api/v1/exam/${id}`);
//       const examData = response?.data?.data;

//       setExam(examData);
//       setSearchResults(examData.questions || []);
//       setName(examData.name || "");
//       setSubject(examData.subject || "");
//       setClassName(examData.class || "");
//       setCategory(examData.category || "");
//       setDuration(examData.duration || "");
//       setTotalMarks(examData.totalMarks || "");
//       setPassingMarks(examData.passingMarks || "");
//       setNegativeMarking(examData.negativeMarking || "");
//       setExamSet(examData.examSet || "");
//       setQuestions(examData.questions || []);
//       setInstituteId(examData.instituteId || "");
//       setVendorId(examData.vendorId || "");
//       setPublicExam(examData.publicExam || "");

//       // Set dates
//       if (examData.startDate) {
//         setStartDate(moment(examData.startDate, "DD/MM/YYYY").toDate());
//       }
//       if (examData.endDate) {
//         setEndDate(moment(examData.endDate, "DD/MM/YYYY").toDate());
//       }

//       // Set times - format from API response
//       if (examData.startTime) {
//         setStartTime(examData.startTime);
//       }
//       if (examData.endTime) {
//         setEndTime(examData.endTime);
//       }

//       // Set course selection if instituteCourseId exists
//       if (examData.instituteCourseId && courses) {
//         const selectedCourse = courses.find(
//           (course) => course._id === examData.instituteCourseId
//         );
//         if (selectedCourse) {
//           setStudentCourse(selectedCourse.name);
//           setStudentCourseId(selectedCourse._id);
//         } else if (examData.instituteCourseId === "81af3e57846a42aab058dc4d") {
//           setStudentCourse("General");
//           setStudentCourseId("81af3e57846a42aab058dc4d");
//         }
//       }
//     } catch (error) {
//       message.error(error?.response?.data?.message || "Failed to fetch exam data");
//     }
//   };

//   // Edit Exam by Id
//   const { confirm } = Modal;

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     confirm({
//       title: "Are you sure you want to Edit this Exam?",
//       content: "This action will update the selected exam details.",
//       okText: "Yes, Edit",
//       cancelText: "No, Cancel",
//       onOk: async () => {
//         try {
//           const updateExamData = {
//             name,
//             subject,
//             class: className,
//             category,
//             duration: parseInt(duration),
//             totalMarks: parseInt(totalMarks),
//             passingMarks: parseInt(passingMarks),
//             negativeMarking: parseFloat(negativeMarking),
//             examSet,
//             startDate: examStartDate,
//             endDate: examEndDate,
//             startTime: startTime,  // Add startTime
//             endTime: endTime,      // Add endTime
//             instituteCourseId: studentCourseId,
//             publicExam,
//             instituteId: instituteId,
//             vendorId: vendorId,
//           };

//           const { data } = await axios.put(
//             `/api/v1/exam/${id}`,
//             updateExamData
//           );

//           if (data.success === true) {
//             message.success(data.message || "Exam updated successfully");
//             getAllExams();
//             localStorage.setItem("examData", JSON.stringify(data));
//           } else {
//             message.error(data.message || "Failed to update exam");
//           }
//         } catch (error) {
//           message.error(
//             error?.response?.data?.message || "Failed to update exam."
//           );
//         }
//       },
//       onCancel() {
//         console.log("Exam update canceled.");
//       },
//     });
//   };

//   // Delete Exam Questions By id
//   const deleteQuestion = async (questionId) => {
//     confirm({
//       title: "Are you sure you want to delete this Question?",
//       content: "Once deleted, this action cannot be undone.",
//       okText: "Yes, Delete",
//       cancelText: "No, Cancel",
//       onOk: async () => {
//         try {
//           const { data } = await axios.delete(
//             `/api/v1/question/${questionId}`
//           );
//           if (data.success === true) {
//             message.success(data.message);
//             getAllExams();
//           } else {
//             message.error(data.message);
//           }
//         } catch (error) {
//           message.error(
//             error?.response?.data?.message || "Failed to delete question."
//           );
//         }
//       },
//       onCancel() {
//         console.log("Delete action canceled.");
//       },
//     });
//   };

//   // Search All Questions
//   const searchAllQuestion = async (e) => {
//     const key = e?.target?.value?.toLowerCase();

//     if (key && questions) {
//       const filteredQuestions = questions.filter((question) => {
//         // Check question questionText/content
//         let nameMatch = false;
//         if (question.questionText) {
//           if (Array.isArray(question.questionText)) {
//             nameMatch = question.questionText.some((item) => {
//               const content = item.content || "";
//               return content.toLowerCase().includes(key);
//             });
//           } else if (typeof question.questionText === 'string') {
//             nameMatch = question.questionText.toLowerCase().includes(key);
//           }
//         }

//         // Check options match
//         let optionsMatch = false;
//         if (question.options && Array.isArray(question.options)) {
//           optionsMatch = question.options.some((option) => {
//             const textMatch = option.text?.toLowerCase()?.includes(key);
//             const imagesMatch = option.images?.some((image) =>
//               image?.toLowerCase()?.includes(key)
//             );
//             return textMatch || imagesMatch;
//           });
//         }

//         // Check correctOptions match
//         let correctOptionsMatch = false;
//         if (question.correctOption && question.options) {
//           correctOptionsMatch = question.correctOption
//             .map((optIndex) => {
//               const correctOption = question.options[optIndex];
//               const textMatch = correctOption?.text?.toLowerCase()?.includes(key);
//               const imagesMatch = correctOption?.images?.some((image) =>
//                 image?.toLowerCase()?.includes(key)
//               );
//               return textMatch || imagesMatch;
//             })
//             .some((match) => match);
//         }

//         return nameMatch || optionsMatch || correctOptionsMatch;
//       });

//       setSearchResults(filteredQuestions);
//     } else {
//       setSearchResults(questions || []);
//     }
//   };

//   const questionsColumns = [
//     {
//       title: "#",
//       dataIndex: "index",
//       render: (text, record, index) => <span>{index + 1}</span>,
//     },
//     {
//       title: "Action",
//       dataIndex: "action",
//       render: (text, record) => (
//         <Box sx={{ display: "flex" }}>
//           <IconButton aria-label="delete" onClick={() => deleteQuestion(record._id)}>
//             <DeleteIcon sx={{ color: "red" }} />
//           </IconButton>
//           <IconButton
//             aria-label="edit"
//             onClick={() => {
//               setSelectedQuestion(record);
//               setEditQuestionModal(true);
//             }}
//           >
//             <EditIcon sx={{ color: "#1976d2" }} />
//           </IconButton>
//         </Box>
//       ),
//     },
//     {
//       title: "Marks",
//       dataIndex:"marks"
//     },
//     {
//       title: "Question",
//       dataIndex: "questionText",
//       render: (text, record) => (
//         <div>
//           {/* Simple text question - not array */}
//           {typeof record.questionText === 'string' && (
//             <div dangerouslySetInnerHTML={{ __html: record.questionText }} />
//           )}

//           {/* If question has image */}
//           {record.questionImage && record.questionImage !== "" && (
//             <img
//               src={record.questionImage}
//               alt="Question"
//               style={{ width: "70px", height: "70px", borderRadius: "50px", marginTop: "5px" }}
//             />
//           )}

//           {/* Legacy support for array format (if any) */}
//           {Array.isArray(record.questionText) && (
//             record.questionText.map((content, index) => {
//               if (content.type === "text") {
//                 return <div key={index} dangerouslySetInnerHTML={{ __html: content.content }} />;
//               }
//               if (content.type === "image") {
//                 return (
//                   <img
//                     key={index}
//                     src={content.content}
//                     alt={`Question ${index}`}
//                     style={{ width: "70px", height: "70px", borderRadius: "50px" }}
//                   />
//                 );
//               }
//               return null;
//             })
//           )}
//         </div>
//       ),
//     },
//     {
//       title: "Options",
//       dataIndex: "options",
//       render: (text, record) => (
//         <div>
//           {record.options && Array.isArray(record.options) && record.options.map((option, index) => (
//             <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }} key={index}>
//               <div
//                 dangerouslySetInnerHTML={{
//                   __html: `${String.fromCharCode(65 + index)}: ${option.text || ""}`,
//                 }}
//                 style={{ marginRight: "10px" }}
//               />
//               {option.image && option.image !== "" && (
//                 <img
//                   src={option.image}
//                   alt={`Option ${String.fromCharCode(65 + index)}`}
//                   style={{
//                     width: "70px",
//                     height: "70px",
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                   }}
//                 />
//               )}
//             </div>
//           ))}
//         </div>
//       ),
//     },
//     {
//       title: "Correct Option",
//       dataIndex: "correctOptions",
//       render: (text, record) => (
//         <div>
//           {record?.correctOptions && Array.isArray(record.correctOptions) && (
//             <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
//               {record.correctOptions.map((correctOpt, idx) => {
//                 const optionIndex = correctOpt.optionIndex;
//                 const option = record.options?.[optionIndex];
//                 const letter = String.fromCharCode(65 + optionIndex);

//                 return (
//                   <div key={idx} style={{
//                     display: "flex",
//                     alignItems: "center",
//                     padding: "4px 8px",
//                     backgroundColor: idx === 0 ? "#e3f2fd" : "#f5f5f5",
//                     borderRadius: "4px",
//                     marginBottom: idx !== record.correctOptions.length - 1 ? "4px" : 0
//                   }}>
//                     <span style={{
//                       fontWeight: "bold",
//                       marginRight: "8px",
//                       color: "#1976d2"
//                     }}>
//                       {letter}:
//                     </span>
//                     <span dangerouslySetInnerHTML={{
//                       __html: option?.text || correctOpt.text || ""
//                     }} />
//                     {option?.image && option.image !== "" && (
//                       <img
//                         src={option.image}
//                         alt={`Option ${letter}`}
//                         style={{
//                           width: "30px",
//                           height: "30px",
//                           borderRadius: "50%",
//                           objectFit: "cover",
//                           marginLeft: "8px"
//                         }}
//                       />
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       ),
//     }
//   ];

//   return (
//     <div>
//       <Box sx={{ width: "100%" }}>
//         <Typography
//           variant="h5"
//           align="center"
//           gutterBottom
//           sx={{
//             mb: 3,
//             fontFamily: "Poppins, sans-serif",
//             color: "#2C3E50",
//             letterSpacing: "2.5px",
//             lineHeight: 1.8,
//           }}
//         >
//           Edit Exam And Question
//         </Typography>

//         <Breadcrumbs
//           aria-label="breadcrumb"
//           sx={{
//             mb: 5,
//             backgroundColor: "#fff",
//             padding: "20px",
//             borderRadius: "12px",
//             boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//           }}
//         >
//           <MUILink
//             component={Link}
//             to="/dashboard"
//             sx={{ color: "inherit", textDecoration: "none" }}
//           >
//             Dashboard
//           </MUILink>
//           <MUILink
//             component={Link}
//             to="/admin/exams"
//             sx={{ color: "inherit", textDecoration: "none" }}
//           >
//             Exams
//           </MUILink>
//           <Typography sx={{ color: "primary.main" }}>
//             Edit Exams And Questions
//           </Typography>
//         </Breadcrumbs>

//         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//           <Tabs
//             value={value}
//             onChange={handleChange}
//             aria-label="basic tabs example"
//           >
//             <Tab label="Exam" {...TabPanel(0)} />
//             <Tab label="Question" {...TabPanel(1)} />
//             <Tab label="Add Question" {...TabPanel(2)} />
//           </Tabs>
//         </Box>

//         {/* Edit Exam Tab */}
//         <CustomTabPanel value={value} index={0}>
//           <Typography
//             variant="h6"
//             sx={{
//               pb: 2,
//               pt: 3,
//               fontFamily: "Poppins, sans-serif",
//               color: "#555",
//               letterSpacing: "2.5px",
//               lineHeight: 1.8,
//             }}
//           >
//             Edit Exam
//           </Typography>

//           <Container
//             onSubmit={handleSubmit}
//             component="form"
//             className="form_style border-style"
//             maxWidth
//           >
//             <Box sx={{ mb: 3 }}>
//               <FormControl fullWidth>
//                 <InputLabel id="public-exam-label">Public Exam</InputLabel>
//                 <Select
//                   labelId="public-exam-label"
//                   id="public-exam"
//                   value={publicExam}
//                   label="Public Exam"
//                   onChange={(e) => setPublicExam(e.target.value)}
//                 >
//                   <MenuItem value="yes">Yes</MenuItem>
//                   <MenuItem value="no">No</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             <TextField
//               sx={{
//                 mb: 3,
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="name"
//               label="Exam Name"
//               name="name"
//               InputLabelProps={{ shrink: true }}
//               placeholder="Exam Name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="subject"
//               label="Subject"
//               name="subject"
//               InputLabelProps={{ shrink: true }}
//               placeholder="Subject"
//               value={subject}
//               onChange={(e) => setSubject(e.target.value)}
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="class"
//               label="Class"
//               name="class"
//               InputLabelProps={{ shrink: true }}
//               placeholder="Class"
//               value={className}
//               onChange={(e) => setClassName(e.target.value)}
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& input[type='number']": {
//                   MozAppearance: "textfield",
//                   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
//                     display: "none",
//                   },
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="duration"
//               label="Duration (mins)"
//               name="duration"
//               type="number"
//               InputLabelProps={{ shrink: true }}
//               placeholder="Duration (mins)"
//               value={duration}
//               onChange={(e) => setDuration(e.target.value)}
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& input[type='number']": {
//                   MozAppearance: "textfield",
//                   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
//                     display: "none",
//                   },
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="totalMarks"
//               label="Total Marks"
//               name="totalMarks"
//               type="number"
//               InputLabelProps={{ shrink: true }}
//               placeholder="Total Marks"
//               value={totalMarks}
//               onChange={(e) => setTotalMarks(e.target.value)}
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& input[type='number']": {
//                   MozAppearance: "textfield",
//                   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
//                     display: "none",
//                   },
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="passingMarks"
//               label="Passing Marks"
//               name="passingMarks"
//               type="number"
//               InputLabelProps={{ shrink: true }}
//               placeholder="Passing Marks"
//               value={passingMarks}
//               onChange={(e) => setPassingMarks(e.target.value)}
//             />

//             <TextField
//               sx={{
//                 mb: 3,
//                 "& input[type='number']": {
//                   MozAppearance: "textfield",
//                   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
//                     display: "none",
//                   },
//                 },
//                 fieldset: { borderColor: "rgb(231, 235, 240)" },
//               }}
//               fullWidth
//               id="negativeMarks"
//               label="Negative Marks"
//               name="negativeMarks"
//               type="number"
//               InputLabelProps={{ shrink: true }}
//               placeholder="Negative Marks"
//               value={negativeMarking}
//               onChange={(e) => setNegativeMarking(e.target.value)}
//             />

//             {/* Date Pickers */}
//             <Box style={{ display: "flex", gap: "20px", marginBottom: "20px" }} className="Date">
//               <Box sx={{ mb: 3 }}>
//                 <DatePicker
//                   showIcon
//                   toggleCalendarOnIconClick
//                   isClearable
//                   placeholderText="Start Date"
//                   selected={startDate}
//                   onChange={handleStartDateChange}
//                   minDate={new Date()}
//                   maxDate={endDate}
//                   required
//                 />
//               </Box>
//               <Box sx={{ mb: 3 }}>
//                 <DatePicker
//                   showIcon
//                   toggleCalendarOnIconClick
//                   isClearable
//                   placeholderText="End Date"
//                   selected={endDate}
//                   onChange={handleEndDateChange}
//                   minDate={startDate || new Date()}
//                   required
//                 />
//               </Box>
//             </Box>

//             {/* Time Pickers */}
//             <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
//               <Box>
//                 <TextField
//                   type="time"
//                   label="Start Time"
//                   value={startTime}
//                   onChange={(e) => setStartTime(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                   sx={{ minWidth: "150px" }}
//                 />
//               </Box>

//               <Box>
//                 <TextField
//                   type="time"
//                   label="End Time"
//                   value={endTime}
//                   onChange={(e) => setEndTime(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                   sx={{ minWidth: "150px" }}
//                 />
//               </Box>
//             </Box>

//             <Button
//               variant="contained"
//               type="submit"
//               color="primary"
//               className="courses_desc"
//               sx={{
//                 mt: 3,
//                 mb: 3,
//                 borderRadius: "5px",
//                 textTransform: "none",
//                 fontFamily: "Poppins, sans-serif",
//                 letterSpacing: ".1rem",
//               }}
//             >
//               Update Exam
//             </Button>
//           </Container>
//         </CustomTabPanel>

//         {/* Questions Tab */}
//         <CustomTabPanel value={value} index={1}>
//           <Typography
//             variant="h6"
//             sx={{
//               pb: 2,
//               pt: 3,
//               fontFamily: "Poppins, sans-serif",
//               color: "#555",
//               letterSpacing: "2.5px",
//               lineHeight: 1.8,
//             }}
//           >
//             Edit Question
//           </Typography>

//           {/* Search Input */}
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Search by Question Name, Options and Correct Option"
//             onChange={searchAllQuestion}
//             InputProps={{
//               startAdornment: (
//                 <IconButton>
//                   <SearchIcon sx={{ color: "#1976d2" }} />
//                 </IconButton>
//               ),
//             }}
//             sx={{
//               mb: 3,
//               bgcolor: "white",
//               borderRadius: "20px",
//               boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
//               "& .MuiOutlinedInput-root": {
//                 "& fieldset": {
//                   border: "none",
//                 },
//                 "&:hover fieldset": {
//                   border: "none",
//                 },
//                 "&.Mui-focused fieldset": {
//                   border: "none",
//                 },
//               },
//             }}
//           />

//           <Box sx={{ mb: 2 }}>
//             <QuestionPaperPDF id={id} />
//           </Box>

//           <Container
//             component="form"
//             className="form_style border-style"
//             maxWidth
//           >
//             <Table
//               id="questions-table"
//               columns={questionsColumns}
//               dataSource={searchResults}
//               pagination={{ pageSize: 10 }}
//               rowKey={(record) => record._id}
//               style={{
//                 width: "100%",
//                 overflowY: "hidden",
//                 overflowX: "scroll",
//               }}
//             />
//           </Container>
//         </CustomTabPanel>

//         {/* Add Question Tab */}
//         <CustomTabPanel value={value} index={2}>
//           <Typography
//             variant="h6"
//             sx={{
//               pb: 2,
//               pt: 3,
//               fontFamily: "Poppins, sans-serif",
//               color: "#555",
//               letterSpacing: "2.5px",
//               lineHeight: 1.8,
//             }}
//           >
//             Add Question
//           </Typography>
//           <AddQuestions vendor_Id={vendorId} institute_Id={instituteId} examId={id} refreshData={getAllExams} />
//         </CustomTabPanel>

//         {/* Edit Question Modal */}
//         {editQuestionModal && (
//           <EditQuestionModal
//             setEditQuestionModal={setEditQuestionModal}
//             editQuestionModal={editQuestionModal}
//             examId={id}
//             refreshData={getAllExams}
//             selectedQuestion={selectedQuestion}
//             setSelectedQuestion={setSelectedQuestion}
//           />
//         )}
//       </Box>
//     </div>
//   );
// }
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Typography,
  Container,
  Box,
  TextField,
  Button,
  Breadcrumbs,
  Link as MUILink,
} from "@mui/material";
import axios from "../../axiosInstance";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { message, Table, Modal } from "antd";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EditQuestionModal from "./EditQuestionModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import QuestionPaperPDF from "./QuestionPaperPDF";
import AddQuestions from "./AddQuestions";
import { useSelector, useDispatch } from "react-redux";
import { getCourses } from "../../redux/actions/admin/courseAction";
import SearchIcon from "@mui/icons-material/Search";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function TabPanel(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function EditExamQuestion() {
  let { id } = useParams();
  const dispatch = useDispatch();
  const { courses } = useSelector((state) => state.courses);
  const [value, setValue] = useState(0);
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [className, setClassName] = useState("");
  const [duration, setDuration] = useState("");
  const [totalMarks, setTotalMarks] = useState("");
  const [passingMarks, setPassingMarks] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [questions, setQuestions] = useState([]);
  const [editQuestionModal, setEditQuestionModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [negativeMarking, setNegativeMarking] = useState("");
  const [examSet, setExamSet] = useState("");
  const [instituteId, setInstituteId] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [studentCourseId, setStudentCourseId] = useState("");
  const [studentCourse, setStudentCourse] = useState("");
  const [publicExam, setPublicExam] = useState("");
  const [category, setCategory] = useState("");
  const [exam, setExam] = useState(null);

  // New state variables for result schedule
  const [resultDate, setResultDate] = useState(null);
  const [resultTime, setResultTime] = useState("");
  const [showResultSchedule, setShowResultSchedule] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  // New function for result date change
  const handleResultDateChange = (date) => {
    setResultDate(date);
  };

  // Format dates for API
  const examStartDate = startDate ? moment(startDate).format("DD/MM/YYYY") : "";
  const examEndDate = endDate ? moment(endDate).format("DD/MM/YYYY") : "";
  const examResultDate = resultDate
    ? moment(resultDate).format("DD/MM/YYYY")
    : "";

  // Fetch all institute courses
  useEffect(() => {
    dispatch(getCourses());
  }, [dispatch]);

  useEffect(() => {
    if (courses) {
      setStudentCourse(courses);
    }
  }, [courses]);

  useEffect(() => {
    getAllExams();
  }, [id]);

  // Handle Institute Course selection change
  const handleChangeStudentCourse = (event) => {
    const selectedCourseName = event.target.value;
    setStudentCourse(selectedCourseName);

    const generalCourseId = "81af3e57846a42aab058dc4d";

    const selectedCourse = courses?.find(
      (course) => course.name === selectedCourseName,
    );

    if (selectedCourse) {
      setStudentCourseId(selectedCourse._id);
    } else if (selectedCourseName === "General") {
      setStudentCourseId(generalCourseId);
    }
  };

  // Get all Exams
  const getAllExams = async () => {
    try {
      const response = await axios.get(`/api/v1/exam/${id}`);
      const examData = response?.data?.data;

      setExam(examData);
      setSearchResults(examData.questions || []);
      setName(examData.name || "");
      setSubject(examData.subject || "");
      setClassName(examData.class || "");
      setCategory(examData.category || "");
      setDuration(examData.duration || "");
      setTotalMarks(examData.totalMarks || "");
      setPassingMarks(examData.passingMarks || "");
      setNegativeMarking(examData.negativeMarking || "");
      setExamSet(examData.examSet || "");
      setQuestions(examData.questions || []);
      setInstituteId(examData.instituteId || "");
      setVendorId(examData.vendorId || "");
      setPublicExam(examData.publicExam || "");

      // Set dates
      if (examData.startDate) {
        setStartDate(moment(examData.startDate, "DD/MM/YYYY").toDate());
      }
      if (examData.endDate) {
        setEndDate(moment(examData.endDate, "DD/MM/YYYY").toDate());
      }

      // Set result dates
      if (examData.resultDate) {
        setResultDate(moment(examData.resultDate, "DD/MM/YYYY").toDate());
        setShowResultSchedule(true);
      }
      if (examData.resultTime) {
        setResultTime(examData.resultTime);
      }

      // Set times - format from API response
      if (examData.startTime) {
        setStartTime(examData.startTime);
      }
      if (examData.endTime) {
        setEndTime(examData.endTime);
      }

      // Set course selection if instituteCourseId exists
      if (examData.instituteCourseId && courses) {
        const selectedCourse = courses.find(
          (course) => course._id === examData.instituteCourseId,
        );
        if (selectedCourse) {
          setStudentCourse(selectedCourse.name);
          setStudentCourseId(selectedCourse._id);
        } else if (examData.instituteCourseId === "81af3e57846a42aab058dc4d") {
          setStudentCourse("General");
          setStudentCourseId("81af3e57846a42aab058dc4d");
        }
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to fetch exam data",
      );
    }
  };

  // Edit Exam by Id
  const { confirm } = Modal;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate result date if result schedule is enabled
    if (showResultSchedule && (!resultDate || !resultTime)) {
      message.warning("Please select result declaration date and time");
      return;
    }

    confirm({
      title: "Are you sure you want to Edit this Exam?",
      content: "This action will update the selected exam details.",
      okText: "Yes, Edit",
      cancelText: "No, Cancel",
      onOk: async () => {
        try {
          const updateExamData = {
            name,
            subject,
            class: className,
            category,
            duration: parseInt(duration),
            totalMarks: parseInt(totalMarks),
            passingMarks: parseInt(passingMarks),
            negativeMarking: parseFloat(negativeMarking),
            examSet,
            startDate: examStartDate,
            endDate: examEndDate,
            startTime: startTime,
            endTime: endTime,
            resultDate: showResultSchedule ? examResultDate : "",
            resultTime: showResultSchedule ? resultTime : "",
            instituteCourseId: studentCourseId,
            publicExam,
            instituteId: instituteId,
            vendorId: vendorId,
          };

          const { data } = await axios.put(
            `/api/v1/exam/${id}`,
            updateExamData,
          );

          if (data.success === true) {
            message.success(data.message || "Exam updated successfully");
            getAllExams();
            localStorage.setItem("examData", JSON.stringify(data));
          } else {
            message.error(data.message || "Failed to update exam");
          }
        } catch (error) {
          message.error(
            error?.response?.data?.message || "Failed to update exam.",
          );
        }
      },
      onCancel() {
        console.log("Exam update canceled.");
      },
    });
  };

  // Delete Exam Questions By id
  const deleteQuestion = async (questionId) => {
    confirm({
      title: "Are you sure you want to delete this Question?",
      content: "Once deleted, this action cannot be undone.",
      okText: "Yes, Delete",
      cancelText: "No, Cancel",
      onOk: async () => {
        try {
          const { data } = await axios.delete(`/api/v1/question/${questionId}`);
          if (data.success === true) {
            message.success(data.message);
            getAllExams();
          } else {
            message.error(data.message);
          }
        } catch (error) {
          message.error(
            error?.response?.data?.message || "Failed to delete question.",
          );
        }
      },
      onCancel() {
        console.log("Delete action canceled.");
      },
    });
  };

  // Search All Questions
  const searchAllQuestion = async (e) => {
    const key = e?.target?.value?.toLowerCase();

    if (key && questions) {
      const filteredQuestions = questions.filter((question) => {
        let nameMatch = false;
        if (question.questionText) {
          if (Array.isArray(question.questionText)) {
            nameMatch = question.questionText.some((item) => {
              const content = item.content || "";
              return content.toLowerCase().includes(key);
            });
          } else if (typeof question.questionText === "string") {
            nameMatch = question.questionText.toLowerCase().includes(key);
          }
        }

        let optionsMatch = false;
        if (question.options && Array.isArray(question.options)) {
          optionsMatch = question.options.some((option) => {
            const textMatch = option.text?.toLowerCase()?.includes(key);
            const imagesMatch = option.images?.some((image) =>
              image?.toLowerCase()?.includes(key),
            );
            return textMatch || imagesMatch;
          });
        }

        let correctOptionsMatch = false;
        if (question.correctOption && question.options) {
          correctOptionsMatch = question.correctOption
            .map((optIndex) => {
              const correctOption = question.options[optIndex];
              const textMatch = correctOption?.text
                ?.toLowerCase()
                ?.includes(key);
              const imagesMatch = correctOption?.images?.some((image) =>
                image?.toLowerCase()?.includes(key),
              );
              return textMatch || imagesMatch;
            })
            .some((match) => match);
        }

        return nameMatch || optionsMatch || correctOptionsMatch;
      });

      setSearchResults(filteredQuestions);
    } else {
      setSearchResults(questions || []);
    }
  };

  const questionsColumns = [
    {
      title: "#",
      dataIndex: "index",
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <Box sx={{ display: "flex" }}>
          <IconButton
            aria-label="delete"
            onClick={() => deleteQuestion(record._id)}
          >
            <DeleteIcon sx={{ color: "red" }} />
          </IconButton>
          <IconButton
            aria-label="edit"
            onClick={() => {
              setSelectedQuestion(record);
              setEditQuestionModal(true);
            }}
          >
            <EditIcon sx={{ color: "#1976d2" }} />
          </IconButton>
        </Box>
      ),
    },
    {
      title: "Marks",
      dataIndex: "marks",
    },
    {
      title: "Question",
      dataIndex: "questionText",
      render: (text, record) => (
        <div>
          {typeof record.questionText === "string" && (
            <div dangerouslySetInnerHTML={{ __html: record.questionText }} />
          )}

          {record.questionImage && record.questionImage !== "" && (
            <img
              src={record.questionImage}
              alt="Question"
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50px",
                marginTop: "5px",
              }}
            />
          )}

          {Array.isArray(record.questionText) &&
            record.questionText.map((content, index) => {
              if (content.type === "text") {
                return (
                  <div
                    key={index}
                    dangerouslySetInnerHTML={{ __html: content.content }}
                  />
                );
              }
              if (content.type === "image") {
                return (
                  <img
                    key={index}
                    src={content.content}
                    alt={`Question ${index}`}
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50px",
                    }}
                  />
                );
              }
              return null;
            })}
        </div>
      ),
    },
    {
      title: "Options",
      dataIndex: "options",
      render: (text, record) => (
        <div>
          {record.options &&
            Array.isArray(record.options) &&
            record.options.map((option, index) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
                key={index}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${String.fromCharCode(65 + index)}: ${option.text || ""}`,
                  }}
                  style={{ marginRight: "10px" }}
                />
                {option.image && option.image !== "" && (
                  <img
                    src={option.image}
                    alt={`Option ${String.fromCharCode(65 + index)}`}
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            ))}
        </div>
      ),
    },
    {
      title: "Correct Option",
      dataIndex: "correctOptions",
      render: (text, record) => (
        <div>
          {record?.correctOptions && Array.isArray(record.correctOptions) && (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              {record.correctOptions.map((correctOpt, idx) => {
                const optionIndex = correctOpt.optionIndex;
                const option = record.options?.[optionIndex];
                const letter = String.fromCharCode(65 + optionIndex);

                return (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "4px 8px",
                      backgroundColor: idx === 0 ? "#e3f2fd" : "#f5f5f5",
                      borderRadius: "4px",
                      marginBottom:
                        idx !== record.correctOptions.length - 1 ? "4px" : 0,
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        marginRight: "8px",
                        color: "#1976d2",
                      }}
                    >
                      {letter}:
                    </span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: option?.text || correctOpt.text || "",
                      }}
                    />
                    {option?.image && option.image !== "" && (
                      <img
                        src={option.image}
                        alt={`Option ${letter}`}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          marginLeft: "8px",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            mb: 3,
            fontFamily: "Poppins, sans-serif",
            color: "#2C3E50",
            letterSpacing: "2.5px",
            lineHeight: 1.8,
          }}
        >
          Edit Exam And Question
        </Typography>

        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            mb: 5,
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <MUILink
            component={Link}
            to="/dashboard"
            sx={{ color: "inherit", textDecoration: "none" }}
          >
            Dashboard
          </MUILink>
          <MUILink
            component={Link}
            to="/admin/exams"
            sx={{ color: "inherit", textDecoration: "none" }}
          >
            Exams
          </MUILink>
          <Typography sx={{ color: "primary.main" }}>
            Edit Exams And Questions
          </Typography>
        </Breadcrumbs>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Exam" {...TabPanel(0)} />
            <Tab label="Question" {...TabPanel(1)} />
            <Tab label="Add Question" {...TabPanel(2)} />
          </Tabs>
        </Box>

        {/* Edit Exam Tab */}
        <CustomTabPanel value={value} index={0}>
          <Typography
            variant="h6"
            sx={{
              pb: 2,
              pt: 3,
              fontFamily: "Poppins, sans-serif",
              color: "#555",
              letterSpacing: "2.5px",
              lineHeight: 1.8,
            }}
          >
            Edit Exam
          </Typography>

          <Container
            onSubmit={handleSubmit}
            component="form"
            className="form_style border-style"
            maxWidth
          >
            <Box sx={{ mb: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="public-exam-label">Public Exam</InputLabel>
                <Select
                  labelId="public-exam-label"
                  id="public-exam"
                  value={publicExam}
                  label="Public Exam"
                  onChange={(e) => setPublicExam(e.target.value)}
                >
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <TextField
              sx={{
                mb: 3,
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="name"
              label="Exam Name"
              name="name"
              InputLabelProps={{ shrink: true }}
              placeholder="Exam Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="subject"
              label="Subject"
              name="subject"
              InputLabelProps={{ shrink: true }}
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="class"
              label="Class"
              name="class"
              InputLabelProps={{ shrink: true }}
              placeholder="Class"
              value={className}
              onChange={(e) => setClassName(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="duration"
              label="Duration (mins)"
              name="duration"
              type="number"
              InputLabelProps={{ shrink: true }}
              placeholder="Duration (mins)"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="totalMarks"
              label="Total Marks"
              name="totalMarks"
              type="number"
              InputLabelProps={{ shrink: true }}
              placeholder="Total Marks"
              value={totalMarks}
              onChange={(e) => setTotalMarks(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="passingMarks"
              label="Passing Marks"
              name="passingMarks"
              type="number"
              InputLabelProps={{ shrink: true }}
              placeholder="Passing Marks"
              value={passingMarks}
              onChange={(e) => setPassingMarks(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="negativeMarks"
              label="Negative Marks"
              name="negativeMarks"
              type="number"
              InputLabelProps={{ shrink: true }}
              placeholder="Negative Marks"
              value={negativeMarking}
              onChange={(e) => setNegativeMarking(e.target.value)}
            />
 <Typography
              variant="h6"
              sx={{
                pb: 1,
                mt: -2,
                fontFamily: "Poppins, sans-serif",
                color: "#555",
                letterSpacing: "2.5px",
                lineHeight: 1.8,
                fontSize: "16px",
              }}
            >
              Configure Exam Schedule
            </Typography>
            
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "1fr 1fr",
                  md: "1fr 1fr 1fr 1fr",
                },
                gap: 2,
                width: "100%",
                mb: 3,
              }}
            >
              {/* Date Pickers */}
              <Box sx={{ display: "flex", gap: "20px", marginBottom: "20px", flexWrap: "wrap" }}>
              <Box sx={{ mb: 3 }}>
                <DatePicker
                  showIcon
                  toggleCalendarOnIconClick
                  isClearable
                  placeholderText="Start Date"
                  selected={startDate}
                  onChange={handleStartDateChange}
                  minDate={new Date()}
                  maxDate={endDate}
                  required
                />
              </Box>
              <Box sx={{ mb: 3 }}>
                <DatePicker
                  showIcon
                  toggleCalendarOnIconClick
                  isClearable
                  placeholderText="End Date"
                  selected={endDate}
                  onChange={handleEndDateChange}
                  minDate={startDate || new Date()}
                  required
                />
              </Box>
              </Box>
              {/* Time Pickers */}
              <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
              <Box>
                <TextField
                  type="time"
                  label="Start Time"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  required
                  sx={{ minWidth: "150px" }}
                />
              </Box>

              <Box>
                <TextField
                  type="time"
                  label="End Time"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  required
                  sx={{ minWidth: "150px" }}
                />
              </Box>
              </Box>
            </Box>

            {/* Result Schedule Section - Optional */}
            <Box sx={{ mt: 2, mb: 2 }}>
              <Button
                variant="outlined"
                onClick={() => setShowResultSchedule(!showResultSchedule)}
                sx={{
                  mb: 2,
                  textTransform: "none",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {showResultSchedule
                  ? "Hide Result Schedule"
                  : "+ Add Result Declaration Schedule (Optional)"}
              </Button>
            </Box>

            {showResultSchedule && (
              <>
                <Typography
                  variant="h6"
                  sx={{
                    pb: 1,
                    fontFamily: "Poppins, sans-serif",
                    color: "#555",
                    letterSpacing: "2.5px",
                    lineHeight: 1.8,
                    fontSize: "16px",
                  }}
                >
                  Configure Result Declaration Schedule
                </Typography>

                <Box
                  sx={{ display: "flex", gap: "20px", mb: 3, flexWrap: "wrap" }}
                >
                  <Box>
                    <DatePicker
                      showIcon
                      toggleCalendarOnIconClick
                      isClearable
                      placeholderText="Result Declaration Date"
                      selected={resultDate}
                      onChange={handleResultDateChange}
                      minDate={endDate || new Date()}
                      required={showResultSchedule}
                    />
                  </Box>

                  <Box>
                    <TextField
                      type="time"
                      label="Result Declaration Time"
                      value={resultTime}
                      onChange={(e) => setResultTime(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      required={showResultSchedule}
                      sx={{ minWidth: "150px" }}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    mb: 2,
                    p: 2,
                    bgcolor: "#e3f2fd",
                    borderRadius: "8px",
                    border: "1px solid #90caf9",
                  }}
                >
                  <Typography variant="body2" color="primary">
                    <strong>ℹ️ Note:</strong> Result will be visible to students
                    only after the specified result declaration date and time.
                    Leave this empty if you want to show results immediately
                    after exam completion.
                  </Typography>
                </Box>
              </>
            )}

            <Button
              variant="contained"
              type="submit"
              color="primary"
              className="courses_desc"
              sx={{
                mt: 3,
                mb: 3,
                borderRadius: "5px",
                textTransform: "none",
                fontFamily: "Poppins, sans-serif",
                letterSpacing: ".1rem",
              }}
            >
              Update Exam
            </Button>
          </Container>
        </CustomTabPanel>

        {/* Questions Tab */}
        <CustomTabPanel value={value} index={1}>
          <Typography
            variant="h6"
            sx={{
              pb: 2,
              pt: 3,
              fontFamily: "Poppins, sans-serif",
              color: "#555",
              letterSpacing: "2.5px",
              lineHeight: 1.8,
            }}
          >
            Edit Question
          </Typography>

          {/* Search Input */}
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search by Question Name, Options and Correct Option"
            onChange={searchAllQuestion}
            InputProps={{
              startAdornment: (
                <IconButton>
                  <SearchIcon sx={{ color: "#1976d2" }} />
                </IconButton>
              ),
            }}
            sx={{
              mb: 3,
              bgcolor: "white",
              borderRadius: "20px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
              },
            }}
          />

          <Box sx={{ mb: 2 }}>
            <QuestionPaperPDF id={id} />
          </Box>

          <Container
            component="form"
            className="form_style border-style"
            maxWidth
          >
            <Table
              id="questions-table"
              columns={questionsColumns}
              dataSource={searchResults}
              pagination={{ pageSize: 10 }}
              rowKey={(record) => record._id}
              style={{
                width: "100%",
                overflowY: "hidden",
                overflowX: "scroll",
              }}
            />
          </Container>
        </CustomTabPanel>

        {/* Add Question Tab */}
        <CustomTabPanel value={value} index={2}>
          <Typography
            variant="h6"
            sx={{
              pb: 2,
              pt: 3,
              fontFamily: "Poppins, sans-serif",
              color: "#555",
              letterSpacing: "2.5px",
              lineHeight: 1.8,
            }}
          >
            Add Question
          </Typography>
          <AddQuestions
            vendor_Id={vendorId}
            institute_Id={instituteId}
            examId={id}
            refreshData={getAllExams}
          />
        </CustomTabPanel>

        {/* Edit Question Modal */}
        {editQuestionModal && (
          <EditQuestionModal
            setEditQuestionModal={setEditQuestionModal}
            editQuestionModal={editQuestionModal}
            examId={id}
            refreshData={getAllExams}
            selectedQuestion={selectedQuestion}
            setSelectedQuestion={setSelectedQuestion}
          />
        )}
      </Box>
    </div>
  );
}
